const TITLE_PREFIX_REGEX = /^\(\d+\+?\)\s/;
const MAX_BADGE_COUNT = 99;
const BADGE_COLOR = '#25D366';

let originalTitle = '';
const originalFaviconHrefs = new Map();

const captureOriginalTitle = () => {
  if (!originalTitle) {
    originalTitle = document.title.replace(TITLE_PREFIX_REGEX, '');
  }
  return originalTitle;
};

const captureOriginalFavicons = () => {
  document.querySelectorAll('.favicon').forEach(favicon => {
    if (!originalFaviconHrefs.has(favicon)) {
      originalFaviconHrefs.set(favicon, favicon.getAttribute('href'));
    }
  });
};

const badgeLabel = count => (count > MAX_BADGE_COUNT ? '99+' : String(count));

const drawNumericFavicon = (image, count, size) => {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  ctx.drawImage(image, 0, 0, size, size);

  const label = badgeLabel(count);
  const radius = size * 0.38;
  const x = size - radius;
  const y = radius;

  ctx.beginPath();
  ctx.arc(x, y, radius, 0, 2 * Math.PI);
  ctx.fillStyle = BADGE_COLOR;
  ctx.fill();
  ctx.lineWidth = Math.max(1, size * 0.08);
  ctx.strokeStyle = '#ffffff';
  ctx.stroke();

  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.font = `bold ${label.length > 2 ? size * 0.3 : size * 0.42}px sans-serif`;
  ctx.fillText(label, x, y + size * 0.03);

  return canvas.toDataURL('image/png');
};

const loadImage = href =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = href;
  });

const parseFaviconSize = favicon => {
  const sizeAttr = favicon.sizes && favicon.sizes[0];
  const parsed = parseInt(sizeAttr, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 32;
};

const restoreFavicons = () => {
  originalFaviconHrefs.forEach((href, favicon) => {
    if (href) favicon.href = href;
  });
};

const applyNumericFavicons = async count => {
  captureOriginalFavicons();
  const favicons = Array.from(document.querySelectorAll('.favicon'));

  await Promise.all(
    favicons.map(async favicon => {
      const originalHref = originalFaviconHrefs.get(favicon);
      if (!originalHref) return;
      const size = parseFaviconSize(favicon);

      try {
        const image = await loadImage(originalHref);
        const dataUrl = drawNumericFavicon(image, count, size);
        if (dataUrl) favicon.href = dataUrl;
      } catch {
        favicon.href = `/favicon-badge-${size}x${size}.png`;
      }
    })
  );
};

const setDocumentTitle = count => {
  const baseTitle = captureOriginalTitle();
  document.title = count > 0 ? `(${badgeLabel(count)}) ${baseTitle}` : baseTitle;
};

const setAppBadge = count => {
  if (typeof navigator === 'undefined') return;

  if (count > 0 && typeof navigator.setAppBadge === 'function') {
    navigator.setAppBadge(count).catch(() => {});
    return;
  }

  if (typeof navigator.clearAppBadge === 'function') {
    navigator.clearAppBadge().catch(() => {});
  }
};

export const setUnreadIndicator = (count = 0) => {
  const unread = Math.max(0, Number(count) || 0);

  setDocumentTitle(unread);
  setAppBadge(unread);

  if (unread > 0) {
    applyNumericFavicons(unread);
    return;
  }

  captureOriginalFavicons();
  restoreFavicons();
};
